import {
	Component,
	OnInit,
	ViewChild,
	ElementRef,
	Input,
	EventEmitter,
	Output
} from "@angular/core";
import { Subscription } from "rxjs/Subscription";
import {
	IComponent,
	IError,
	IReviewer,
	IApplicationModel,
	IReviewerModel,
	IApplicationForm,
	IStepModel,
	IApplicationsModel
} from "../../interfaces";
import {
	FormBuilder,
	FormGroup,
	FormControl,
	FormArray,
	Validators,
	ValidatorFn,
	AbstractControl,
	ReactiveFormsModule,
	FormsModule,
	FormGroupName,
	FormArrayName
} from "@angular/forms";

// services
import * as srv from "../../services";
// Enums
import { MessageTypeEnum, ApplicationStatusEnum } from "../../enums";
import { INotify } from "../../interfaces/inotify";
import { Observable } from "rxjs/Observable";
import { Data } from "@angular/router";
import { LevelBaseInformationComponent } from "../../../modules/levels/level-base/level-base-information/level-base-information.component";
import { _MatProgressSpinnerMixinBase } from "@angular/material";
import { AppModule } from "../../../app.module";
import { ApplicationModel } from "../../classes";
//import { BehaviorSubject } from 'rxjs';

@Component({
	selector: "app-prompt",
	templateUrl: "./prompt.component.html",
	styleUrls: ["./prompt.component.scss"]
})
export class PromptComponent implements IComponent, OnInit {
	// implement icomponent
	name = "PromptComponent";
	subscriptions: Subscription[] = [];
	hide: boolean;
	prompt: IError;
	complexForm: FormGroup;
	visibleTypicalButtons = true;
	saveAppWithOK = false;
	saveTryAgain = false;
	@Output()
	Click = new EventEmitter<number>(true);
	@Output()
	change = new EventEmitter(true);
	// @Input() SAVEDISABLED = false;
	// @Input() COMPONENT: string;
	// @Output() Click = new EventEmitter(true);

	constructor(
		private _loaderSrv: srv.LoaderService,
		private _helperSrv: srv.HelperService,
		private _reviewerSrv: srv.ReviewerService,
		private _logSrv: srv.LogService,
		private _promptSrv: srv.PromptService,
		private _applicationSrv: srv.ApplicationService
	) {
		this.name = "PromptComponent";
	}

	ngOnInit() {
		this.subscriptions.push(
			this._promptSrv.showPrompt$.subscribe((prompt: IError) => {
				this.prompt = prompt;
				this.saveAppWithOK =
					this.prompt.message.indexOf(
						"Please save your application"
					) > -1;
				this.saveTryAgain =
					this.prompt.message
						.toLowerCase()
						.indexOf("your ed does not meet the minimum req") > -1;

				if (this.saveAppWithOK || this.saveTryAgain) {
					this.visibleTypicalButtons = false;
				}

				if (
					this.prompt.message.toLowerCase().indexOf("download") > -1
				) {
					this.visibleTypicalButtons = false;
				}

				//hide the popup for now
				this.hide = false;
			})
		);

		this.subscriptions.push(
			this._promptSrv.hidePrompt$.subscribe(() => {
				//hide the popup for now
				this.hide = true;
			})
		);
	}

	OnSave() {
		this.OnClose();
	}

	OnClose() {
		this.hide = true;
	}

	OnClear() {
		//clear form
		this.hide = true;
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/prompt/prompt.component.ts